exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sync-line[data-v-61d95362]{position:relative;margin-bottom:12px;text-align:center;color:#005aaa;font-size:28px}.sync-line[data-v-61d95362]:after,.sync-line[data-v-61d95362]:before{content:\"\";position:absolute;top:50%;width:40%;border-top:1px solid #005aaa}.sync-line[data-v-61d95362]:before{left:0}.sync-line[data-v-61d95362]:after{right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-61d95362","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/CrmAuth.vue
// module id = 209
// module chunks = 0